package game.scene

import com.soywiz.klock.seconds
import com.soywiz.korge.scene.Scene
import com.soywiz.korge.view.Container
import com.soywiz.korim.format.readBitmap
import com.soywiz.korio.async.delay
import com.soywiz.korio.async.launch
import com.soywiz.korio.file.std.resourcesVfs
import game.*
import view.PlayTerminal
import view.Terminal

class LoadScene : Scene() {
    private lateinit var terminal: Terminal
    private var cursorRow = 0

    private val filePrefix = "A:\\GODLAIR\\"
    private val roomPrefix = "${filePrefix}ROOM\\"
    private val soundPrefix = "${filePrefix}SFX\\"
    private val spritePrefix = "${filePrefix}SPRITE\\"

    override suspend fun Container.sceneInit() {
        launch {
//            val logoBitmap = resourcesVfs["logo.png"].readBitmap()
//            val logo = image(logoBitmap) {
//                xy(views.gameWindow.width / 2 - logoBitmap.width / 2, 0)
//            }
//
            val fontBitmap = resourcesVfs["cgafont.png"].readBitmap()

            val font = CgaFont(fontBitmap)

            terminal = Terminal(font, 80, 25)
            terminal.scale = 4.0
            addChild(terminal)
            terminal.scale = 2.0
            terminal.fillRect(0, 0, 79, 24, 32, CgaColor.LIGHT_GRAY, CgaColor.BLACK)
            launch {
                printLine("")
                printLine("")
                printLine("A:\\WISHLAIR.BAT")
                printLine("Copyright (C) 2021 Chronogears Inc.")
                printLine("Loading Wishlair...")
                // Load Settings
                printLine("Loading settings.cfg")
                val settings = loadSettings()

                // Load strings
                printLine("Loading strings...")
                val strings = loadStrings()

                // Load rooms
                printLine("Loading rooms...")
                val rooms = loadRooms() {
                    print(it)
                }

                printLine("")

                // Load sounds
                printLine("Loading sounds...")
                val sounds = loadSounds() {
                    print(it)
                }

                // Sprites
                printLine("Loading sprites...")
                val sprites = loadSprites(rooms)

                printLine("Initializing CGA TEXTMODE 80x25")

                delay(2.seconds)

                println("Done Loading!")

                val godlair = Game(settings, strings, font, rooms, sprites, sounds, views)
                val playTerminal = PlayTerminal(godlair, views.input)
                playTerminal.startPlay()
                addChild(playTerminal)

                removeChild(terminal)
//                removeChild(logo)
            }
        }

        println("Done!")
    }


    private fun print(text: String) {
        println(text)

        terminal.drawString(0, cursorRow, text, CgaColor.LIGHT_GRAY, CgaColor.BLACK)
    }

    private fun printLine(text: String) {

        print(text)
        cursorRow++
        if (cursorRow == 25) {
            // Scroll
            for (row in 1..24) {
                for (col in 0..79) {
                    val sourceChar = terminal.getChar(col, row)
                    val destChar = terminal.getChar(col, row - 1)

                    destChar.char = sourceChar.char
                    destChar.fgColor = sourceChar.fgColor
                    destChar.bgColor = sourceChar.bgColor
                }
            }

            terminal.drawString(0, 24, " ".repeat(80), CgaColor.LIGHT_GRAY, CgaColor.BLACK)
            cursorRow--
        }
    }
}
